// ABOUTME: The 2px line marking where a dragged row will land
// ABOUTME: Inset by default; the wide variant spans the row and marks its start with a dot

import type { Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge"

interface CDropLineProps {
  /** Which side of the row the dragged one would land on; null (or a left/right edge) draws nothing. */
  edge: Edge | null
  /**
   * `inset` is held off the row's edges, so it reads as a gap in the list, not a border.
   * `wide` spans the row and sits 1px outside it, with a dot at the start — for lists of
   * cards, where the line has to read against the card rather than inside it.
   */
  variant?: "inset" | "wide"
}

export const CDropLine = ({ edge, variant = "inset" }: CDropLineProps) => {
  if (edge !== "top" && edge !== "bottom") return null

  const isTop = edge === "top"

  // Both variants need a positioned ancestor — the row they belong to.
  if (variant === "wide") {
    return (
      <div
        aria-hidden
        className={`pointer-events-none absolute inset-x-0 z-10 h-0.5 bg-blue-500 ${isTop ? "-top-px" : "-bottom-px"}`}
      >
        <div className="absolute -left-1 -top-[3px] h-2 w-2 rounded-full bg-blue-500" />
      </div>
    )
  }

  return (
    <span
      aria-hidden
      className={`pointer-events-none absolute inset-x-5 z-10 h-0.5 bg-blue-600 ${isTop ? "top-0" : "bottom-0"}`}
    />
  )
}
